import { lazy } from 'react';

export const YourBirthDatePageLazy = lazy(() => import('./your-birthdate'));
